import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navdata',
  templateUrl: './navdata.component.html',
  styleUrls: ['./navdata.component.css']
})
export class NavdataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
